import { useMediaQuery } from "@mantine/hooks";

/**
 * True when the primary pointer is a finger, as on phones and tablets: the same
 * `(pointer: coarse)` condition the CSS uses for 44px touch targets.
 */
export function useIsTouchScreen(): boolean {
  return useMediaQuery("(pointer: coarse)", undefined, { getInitialValueInEffect: false });
}
